export const PRODUCT_IDENTITY = {
  name: "INSPECT IA",
  palette: {
    primary: "#3C3C3C",
    graphite700: "#515151",
    graphite600: "#666666",
    graphite400: "#8C8C8C",
    graphite300: "#B5B5B5"
  }
} as const;
